import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withModifiers as _withModifiers } from "vue"
import _imports_0 from '@/assets/images/admin-img/image-icon.svg'
import _imports_1 from '@/assets/images/admin-img/light_delete-outline.svg'


const _hoisted_1 = { id: "mainContainer" }
const _hoisted_2 = { class: "admin-mid-container" }
const _hoisted_3 = {
  class: "admin-custom-row admin-page-row",
  id: "leftMenuSlideBox"
}
const _hoisted_4 = { class: "admin-right-sidebar" }
const _hoisted_5 = { class: "admin-right-sidebar-in" }
const _hoisted_6 = { class: "admin-right-sidebar-in-top" }
const _hoisted_7 = { class: "admin-custom-row" }
const _hoisted_8 = { class: "admin-right-sidebar-in-top-left" }
const _hoisted_9 = { class: "admin-page-type-links" }
const _hoisted_10 = { class: "admin-right-sidebar-in-top-right" }
const _hoisted_11 = { class: "admin-right-sidebar-in-top-right-top" }
const _hoisted_12 = { class: "admin-search-box" }
const _hoisted_13 = { class: "admin-add-btn" }
const _hoisted_14 = {
  key: 0,
  class: "admin-right-sidebar-in-top-right-btm"
}
const _hoisted_15 = { class: "tags" }
const _hoisted_16 = { class: "delete-all-btn-link" }
const _hoisted_17 = {
  key: 0,
  class: "white-bg-border add-new-section"
}
const _hoisted_18 = { class: "add-banner-image-section" }
const _hoisted_19 = { class: "add-banner-image-box" }
const _hoisted_20 = { class: "admin-input-field" }
const _hoisted_21 = ["value"]
const _hoisted_22 = {
  key: 0,
  class: "error-msg"
}
const _hoisted_23 = { class: "admin-input-field" }
const _hoisted_24 = {
  key: 0,
  class: "error-msg"
}
const _hoisted_25 = { class: "admin-input-field" }
const _hoisted_26 = { class: "image-upload-input upload-banner-image" }
const _hoisted_27 = { class: "file-input-box" }
const _hoisted_28 = {
  key: 0,
  class: "image-upload-input-item-in"
}
const _hoisted_29 = {
  key: 1,
  class: "image-upload-input-item-uploaded"
}
const _hoisted_30 = ["src"]
const _hoisted_31 = {
  key: 0,
  class: "error-msg"
}
const _hoisted_32 = { class: "admin-input-field-submit" }
const _hoisted_33 = ["disabled"]
const _hoisted_34 = {
  class: "admin-item-list-section-in",
  ref: "scrollWrapper",
  "data-simplebar": ""
}
const _hoisted_35 = { class: "admin-item-list-section-scroll" }
const _hoisted_36 = { class: "admin-item-list-top" }
const _hoisted_37 = { class: "admin-item-list-row" }
const _hoisted_38 = { class: "admin-item-checkbox" }
const _hoisted_39 = { class: "admin-checkbox-input" }
const _hoisted_40 = ["checked"]
const _hoisted_41 = { class: "admin-item-banner-image" }
const _hoisted_42 = { class: "admin-item-actions" }
const _hoisted_43 = { class: "admin-item-list-btm" }
const _hoisted_44 = { ref: "sortableList" }
const _hoisted_45 = { class: "admin-item-box-top" }
const _hoisted_46 = { class: "admin-item-list-row" }
const _hoisted_47 = { class: "admin-item-checkbox" }
const _hoisted_48 = { class: "admin-checkbox-input" }
const _hoisted_49 = ["id", "onChange", "checked"]
const _hoisted_50 = ["for"]
const _hoisted_51 = { class: "admin-item-banner-image" }
const _hoisted_52 = { class: "admin-item-banner-image-box" }
const _hoisted_53 = ["src"]
const _hoisted_54 = { class: "admin-item-page-name text-limit" }
const _hoisted_55 = { class: "admin-item-title text-limit" }
const _hoisted_56 = { class: "admin-item-actions" }
const _hoisted_57 = { class: "admin-action-link" }
const _hoisted_58 = ["onClick"]
const _hoisted_59 = ["onClick"]
const _hoisted_60 = ["onClick"]
const _hoisted_61 = ["onClick"]
const _hoisted_62 = {
  key: 0,
  class: "admin-item-box-btm"
}
const _hoisted_63 = { class: "add-banner-image-section" }
const _hoisted_64 = { class: "add-banner-image-box" }
const _hoisted_65 = { class: "admin-input-field" }
const _hoisted_66 = ["value"]
const _hoisted_67 = {
  key: 0,
  class: "error-msg"
}
const _hoisted_68 = { class: "admin-input-field" }
const _hoisted_69 = {
  key: 0,
  class: "error-msg"
}
const _hoisted_70 = { class: "admin-input-field" }
const _hoisted_71 = { class: "image-upload-input upload-banner-image" }
const _hoisted_72 = { class: "image-upload-input-item uploaded-done" }
const _hoisted_73 = { class: "file-input-box" }
const _hoisted_74 = { class: "image-upload-input-item-uploaded" }
const _hoisted_75 = ["src"]
const _hoisted_76 = {
  key: 0,
  class: "error-msg"
}
const _hoisted_77 = { class: "admin-input-field-submit" }
const _hoisted_78 = ["onClick"]
const _hoisted_79 = { class: "admin-pagination-section" }
const _hoisted_80 = { class: "custom-row" }
const _hoisted_81 = { class: "item-show-selectbox" }
const _hoisted_82 = {
  key: 0,
  class: "admin-pagination",
  id: "paginationBox"
}
const _hoisted_83 = ["onClick"]
const _hoisted_84 = { key: 2 }
const _hoisted_85 = { class: "admin-site-footer" }
const _hoisted_86 = { class: "container" }
const _hoisted_87 = {
  class: "modal fade confirmation-popup",
  id: "deletePop",
  tabindex: "-1",
  role: "dialog",
  "aria-labelledby": "deleteModalLabel",
  "aria-hidden": "true",
  "data-bs-backdrop": "static"
}
const _hoisted_88 = {
  class: "modal-dialog",
  role: "document"
}
const _hoisted_89 = { class: "modal-content" }
const _hoisted_90 = { class: "confirmation-popup-mid" }
const _hoisted_91 = { class: "confirmation-popup-btm" }
const _hoisted_92 = {
  id: "popNoBtn",
  class: "admin-btn-outline-secondary",
  "data-bs-dismiss": "modal"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_adminHeader = _resolveComponent("adminHeader")!
  const _component_adminNavigation = _resolveComponent("adminNavigation")!
  const _component_ckeditor = _resolveComponent("ckeditor")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(_component_adminHeader),
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_adminNavigation),
        _createElementVNode("section", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("h1", null, _toDisplayString(_ctx.constants.MANAGE_BANNER_TEXT), 1),
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("ul", null, [
                      _createElementVNode("li", null, [
                        _createElementVNode("a", {
                          id: "allLink",
                          href: "#",
                          class: _normalizeClass({ active: _ctx.activeTab === 'all' }),
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.switchView('all')))
                        }, [
                          _createTextVNode(_toDisplayString(_ctx.constants.ALL_LINK) + " ", 1),
                          _createElementVNode("span", null, _toDisplayString(_ctx.counts.all), 1)
                        ], 2)
                      ]),
                      _createElementVNode("li", null, [
                        _createElementVNode("a", {
                          id: "publishedhLink",
                          href: "#",
                          class: _normalizeClass({ active: _ctx.activeTab === 'published' }),
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.switchView('published')))
                        }, [
                          _createTextVNode(_toDisplayString(_ctx.constants.PUBLISHED_LINK) + " ", 1),
                          _createElementVNode("span", null, _toDisplayString(_ctx.counts.published), 1)
                        ], 2)
                      ]),
                      _createElementVNode("li", null, [
                        _createElementVNode("a", {
                          id: "unPublishedhLink",
                          href: "#",
                          class: _normalizeClass({ active: _ctx.activeTab === 'unpublished' }),
                          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.switchView('unpublished')))
                        }, [
                          _createTextVNode(_toDisplayString(_ctx.constants.UNPUBLISHED_LINK) + " ", 1),
                          _createElementVNode("span", null, _toDisplayString(_ctx.counts.unpublished), 1)
                        ], 2)
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, [
                      _withDirectives(_createElementVNode("input", {
                        id: "seachBannerInput",
                        type: "text",
                        placeholder: "Search Banner",
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.searchedText) = $event)),
                        onKeyup: _cache[4] || (_cache[4] = _withKeys(($event: any) => (_ctx.fetchBanners(_ctx.activeTab), _ctx.fetchCounts(_ctx.searchedText)), ["enter"]))
                      }, null, 544), [
                        [_vModelText, _ctx.searchedText]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_13, [
                      _createElementVNode("button", {
                        id: "addBannerBtn",
                        class: _normalizeClass(["add-btn-admin", { 'active': _ctx.showAddForm }]),
                        onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.showAddForm = true, _ctx.selectedBanners = [], _ctx.selectAll = false, _ctx.cancelEdit()))
                      }, [
                        _cache[27] || (_cache[27] = _createElementVNode("i", { class: "add-icon" }, null, -1)),
                        _createTextVNode(" " + _toDisplayString(_ctx.constants.ADD_BANNER_BUTTON), 1)
                      ], 2)
                    ])
                  ]),
                  (_ctx.selectedBanners.length > 1)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                        _createElementVNode("div", _hoisted_15, [
                          _createElementVNode("ul", null, [
                            _createElementVNode("li", null, [
                              _createElementVNode("span", null, _toDisplayString(_ctx.selectedBanners.length) + " entries selected", 1),
                              _createElementVNode("button", {
                                id: "tagCloseBtn",
                                onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.selectedBanners = [], _ctx.selectAll = false))
                              })
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_16, [
                          _createElementVNode("button", {
                            class: "btn_link",
                            id: "deleteAllBtn",
                            "data-bs-toggle": "modal",
                            "data-bs-target": "#deletePop",
                            onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.setDeleteMode('all')))
                          }, _toDisplayString(_ctx.constants.DELETE_ALL_BUTTON), 1)
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ]),
            (_ctx.showAddForm)
              ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                  _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("h2", null, _toDisplayString(_ctx.constants.ADD_NEW_BANNER_TEXT), 1),
                    _createElementVNode("div", _hoisted_19, [
                      _createElementVNode("form", {
                        id: "addBannerImageForm",
                        onSubmit: _cache[13] || (_cache[13] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitForm && _ctx.submitForm(...args)), ["prevent"]))
                      }, [
                        _createElementVNode("div", _hoisted_20, [
                          _createElementVNode("label", null, _toDisplayString(_ctx.constants.PAGE_LABEL), 1),
                          _withDirectives(_createElementVNode("select", {
                            id: "bnrPgSelectPageSelectBox",
                            class: "admin-selectbox",
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.newBanner.selectedPage) = $event))
                          }, [
                            _cache[28] || (_cache[28] = _createElementVNode("option", { value: "" }, "Select Page", -1)),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pageChoices, (value, key) => {
                              return (_openBlock(), _createElementBlock("option", {
                                key: key,
                                value: value
                              }, _toDisplayString(key), 9, _hoisted_21))
                            }), 128))
                          ], 512), [
                            [_vModelSelect, _ctx.newBanner.selectedPage]
                          ]),
                          (!_ctx.newBanner.selectedPage)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_22, _toDisplayString(_ctx.errMsg), 1))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_23, [
                          _createElementVNode("label", null, _toDisplayString(_ctx.constants.TITLE_LABEL), 1),
                          _createVNode(_component_ckeditor, {
                            id: "bnrPgTitleInput",
                            type: "text",
                            modelValue: _ctx.newBanner.title,
                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.newBanner.title) = $event)),
                            editor: _ctx.editor,
                            placeholder: "Enter the Title",
                            config: _ctx.editorConfig
                          }, null, 8, ["modelValue", "editor", "config"]),
                          (!_ctx.newBanner.title)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_24, _toDisplayString(_ctx.errMsg), 1))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_25, [
                          _createElementVNode("label", null, _toDisplayString(_ctx.constants.BANNER_IMAGE_LABEL), 1),
                          _createElementVNode("div", _hoisted_26, [
                            _createElementVNode("div", {
                              class: _normalizeClass(['image-upload-input-item', { 'uploaded-done': _ctx.imageUploaded }])
                            }, [
                              _createElementVNode("button", {
                                class: "image-upload-input-item-delete-btn",
                                id: "uploaded-img-delete-btn",
                                type: "button",
                                onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.clearUploadedImage(false)))
                              }),
                              _createElementVNode("div", _hoisted_27, [
                                _createElementVNode("input", {
                                  id: "addBnrPgFileInput",
                                  type: "file",
                                  onChange: _cache[11] || (_cache[11] = ($event: any) => (_ctx.handleFileUpload($event, false))),
                                  accept: "image/jpeg,image/jpg,image/png"
                                }, null, 32)
                              ]),
                              (!_ctx.imageUploaded)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                                    _cache[29] || (_cache[29] = _createElementVNode("div", { class: "image-upload-input-item-icon" }, [
                                      _createElementVNode("img", {
                                        src: _imports_0,
                                        alt: ""
                                      })
                                    ], -1)),
                                    _createElementVNode("span", null, _toDisplayString(_ctx.constants.ADD_BANNER_IMAGE_LABEL), 1)
                                  ]))
                                : _createCommentVNode("", true),
                              (_ctx.imageUploaded)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                                    _createElementVNode("img", {
                                      src: _ctx.imageUrl,
                                      alt: "",
                                      class: "mCS_img_loaded"
                                    }, null, 8, _hoisted_30)
                                  ]))
                                : _createCommentVNode("", true)
                            ], 2)
                          ]),
                          (!_ctx.selectedFile)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_31, _toDisplayString(_ctx.errMsg), 1))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_32, [
                          _createElementVNode("button", {
                            id: "bnrPgSubmitBtn",
                            type: "submit",
                            class: "admin-btn-outline-primary add-new-cancel",
                            disabled: _ctx.isSubmitting
                          }, _toDisplayString(_ctx.constants.SUBMIT_BUTTON), 9, _hoisted_33),
                          _createElementVNode("button", {
                            id: "bnrPgCancelBtn",
                            type: "button",
                            class: "admin-btn-outline-secondary add-new-cancel",
                            onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.resetForm && _ctx.resetForm(...args)))
                          }, _toDisplayString(_ctx.constants.CANCEL_BUTTON), 1)
                        ])
                      ], 32)
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.editBannersData.length > 0)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  class: _normalizeClass(['admin-item-list-section banner-image-section', { 'show-edit-item-outer': _ctx.editFormSubmitted }])
                }, [
                  _createElementVNode("div", _hoisted_34, [
                    _createElementVNode("div", _hoisted_35, [
                      _createElementVNode("div", _hoisted_36, [
                        _createElementVNode("div", _hoisted_37, [
                          _createElementVNode("div", _hoisted_38, [
                            _createElementVNode("div", _hoisted_39, [
                              _createElementVNode("input", {
                                name: "cssCheckbox",
                                id: "selectAll",
                                type: "checkbox",
                                class: "css-checkbox",
                                onChange: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.toggleSelectAll && _ctx.toggleSelectAll(...args))),
                                checked: _ctx.selectAll === true
                              }, null, 40, _hoisted_40),
                              _cache[30] || (_cache[30] = _createElementVNode("label", { for: "selectAll" }, null, -1))
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_41, _toDisplayString(_ctx.constants.BANNER_IMAGE_LABEL), 1),
                          _createElementVNode("div", {
                            class: "admin-item-page-name",
                            onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.toggleSort('selectedPage'))),
                            style: {"cursor":"pointer"}
                          }, [
                            _createTextVNode(_toDisplayString(_ctx.constants.PAGE_LABEL) + " ", 1),
                            (_ctx.sortBy === 'selectedPage' || _ctx.sortBy === '-selectedPage')
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 0,
                                  class: _normalizeClass(["sorting-btn", { 'sorted': _ctx.sortBy === '-selectedPage' }])
                                }, null, 2))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("div", {
                            class: "admin-item-title",
                            onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.toggleSort('title'))),
                            style: {"cursor":"pointer"}
                          }, [
                            _createTextVNode(_toDisplayString(_ctx.constants.TITLE_LABEL) + " ", 1),
                            (_ctx.sortBy === 'title' || _ctx.sortBy === '-title')
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 0,
                                  class: _normalizeClass(["sorting-btn", { 'sorted': _ctx.sortBy === '-title' }])
                                }, null, 2))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("div", _hoisted_42, _toDisplayString(_ctx.constants.ACTIONS_LABEL), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_43, [
                        _createElementVNode("div", _hoisted_44, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.editBannersData, (banner, index) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: banner.id,
                              class: _normalizeClass(['admin-item-box', { 'show-edit-item': banner.editing }])
                            }, [
                              _createElementVNode("div", _hoisted_45, [
                                _createElementVNode("div", _hoisted_46, [
                                  _createElementVNode("div", _hoisted_47, [
                                    _createElementVNode("div", _hoisted_48, [
                                      _createElementVNode("input", {
                                        name: "cssCheckbox",
                                        id: 'demo_opt_' + banner.id,
                                        type: "checkbox",
                                        class: "css-checkbox",
                                        onChange: ($event: any) => (_ctx.toggleBannerSelection(banner.id)),
                                        checked: _ctx.selectedBanners.includes(banner.id)
                                      }, null, 40, _hoisted_49),
                                      _createElementVNode("label", {
                                        for: 'demo_opt_' + banner.id
                                      }, null, 8, _hoisted_50)
                                    ])
                                  ]),
                                  _createElementVNode("div", _hoisted_51, [
                                    _createElementVNode("div", _hoisted_52, [
                                      _createElementVNode("img", {
                                        src: _ctx.getCdnImageAddress(banner.bannerImage , `w_76,h_37/`) || '@/assets/images/admin-img/demo-img/item-img-1.jpg',
                                        alt: ""
                                      }, null, 8, _hoisted_53)
                                    ])
                                  ]),
                                  _createElementVNode("div", _hoisted_54, _toDisplayString(banner.selectedPage), 1),
                                  _createElementVNode("div", _hoisted_55, _toDisplayString(_ctx.useStripHtml(banner.title)), 1),
                                  _createElementVNode("div", _hoisted_56, [
                                    _createElementVNode("ul", _hoisted_57, [
                                      _createElementVNode("li", null, [
                                        _createElementVNode("button", {
                                          id: "bnrPgEditBtn",
                                          class: "editBtn",
                                          onClick: ($event: any) => (_ctx.editBanner(index), _ctx.showAddForm = false)
                                        }, _toDisplayString(_ctx.constants.EDIT_BUTTON), 9, _hoisted_58)
                                      ]),
                                      _createElementVNode("li", null, [
                                        _createElementVNode("button", {
                                          id: "bnrPgDeleteBtn",
                                          "data-bs-toggle": "modal",
                                          "data-bs-target": "#deletePop",
                                          onClick: ($event: any) => (_ctx.setDeleteMode('single', banner.id), _ctx.showAddForm = false, _ctx.cancelEdit())
                                        }, _toDisplayString(_ctx.constants.DELETE_BUTTON), 9, _hoisted_59)
                                      ]),
                                      _createElementVNode("li", null, [
                                        (banner.status === 1)
                                          ? (_openBlock(), _createElementBlock("button", {
                                              key: 0,
                                              id: "bnrPgUnPublishBtn",
                                              class: "primary-outline-btn",
                                              onClick: ($event: any) => (_ctx.changeBannerStatus(banner.id, 0))
                                            }, _toDisplayString(_ctx.constants.UNPUBLISH_BUTTON), 9, _hoisted_60))
                                          : (banner.status === 0)
                                            ? (_openBlock(), _createElementBlock("button", {
                                                key: 1,
                                                id: "bnrPgPublishBtn",
                                                class: "primary-outline-btn",
                                                onClick: ($event: any) => (_ctx.changeBannerStatus(banner.id, 1))
                                              }, _toDisplayString(_ctx.constants.PUBLISH_BUTTON), 9, _hoisted_61))
                                            : _createCommentVNode("", true)
                                      ])
                                    ])
                                  ])
                                ])
                              ]),
                              (banner.editing)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_62, [
                                    _createElementVNode("div", _hoisted_63, [
                                      _createElementVNode("h2", null, _toDisplayString(_ctx.constants.EDIT_BANNER_TEXT), 1),
                                      _createElementVNode("div", _hoisted_64, [
                                        _createElementVNode("div", _hoisted_65, [
                                          _createElementVNode("label", null, _toDisplayString(_ctx.constants.PAGE_LABEL), 1),
                                          _withDirectives(_createElementVNode("select", {
                                            id: "bnrPgSelectPageSelectBox",
                                            class: "admin-selectbox",
                                            "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.editBannerData.selectedPage) = $event))
                                          }, [
                                            _cache[31] || (_cache[31] = _createElementVNode("option", { value: "" }, "Select Page", -1)),
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pageChoices, (value, key) => {
                                              return (_openBlock(), _createElementBlock("option", {
                                                key: key,
                                                value: value
                                              }, _toDisplayString(key), 9, _hoisted_66))
                                            }), 128))
                                          ], 512), [
                                            [_vModelSelect, _ctx.editBannerData.selectedPage]
                                          ]),
                                          (!_ctx.editBannerData.selectedPage)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_67, _toDisplayString(_ctx.errEditMsg), 1))
                                            : _createCommentVNode("", true)
                                        ]),
                                        _createElementVNode("div", _hoisted_68, [
                                          _createElementVNode("label", null, _toDisplayString(_ctx.constants.TITLE_LABEL), 1),
                                          _createVNode(_component_ckeditor, {
                                            id: "bnrPgEditTitleInput",
                                            modelValue: _ctx.editBannerData.title,
                                            "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.editBannerData.title) = $event)),
                                            editor: _ctx.editor,
                                            placeholder: "Enter the Title",
                                            config: _ctx.editorConfig
                                          }, null, 8, ["modelValue", "editor", "config"]),
                                          (!_ctx.editBannerData.title)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_69, _toDisplayString(_ctx.errEditMsg), 1))
                                            : _createCommentVNode("", true)
                                        ]),
                                        _createElementVNode("div", _hoisted_70, [
                                          _createElementVNode("label", null, _toDisplayString(_ctx.constants.BANNER_IMAGE_LABEL), 1),
                                          _createElementVNode("div", _hoisted_71, [
                                            _createElementVNode("div", _hoisted_72, [
                                              _createElementVNode("button", {
                                                class: "image-upload-input-item-delete-btn",
                                                type: "button",
                                                onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.clearUploadedImage(true)))
                                              }),
                                              _createElementVNode("div", _hoisted_73, [
                                                _createElementVNode("input", {
                                                  id: "editBnrPgFileInput",
                                                  type: "file",
                                                  onChange: _cache[20] || (_cache[20] = ($event: any) => (_ctx.handleFileUpload($event, true))),
                                                  accept: "image/jpeg,image/jpg,image/png"
                                                }, null, 32)
                                              ]),
                                              _createElementVNode("div", _hoisted_74, [
                                                _createElementVNode("img", {
                                                  src: _ctx.editimageSrc || require('@/assets/images/admin-img/image-icon.svg'),
                                                  alt: ""
                                                }, null, 8, _hoisted_75)
                                              ])
                                            ])
                                          ]),
                                          (!_ctx.selectedEditFile && !_ctx.editimageSrc)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_76, _toDisplayString(_ctx.errEditMsg), 1))
                                            : _createCommentVNode("", true)
                                        ]),
                                        _createElementVNode("div", _hoisted_77, [
                                          _createElementVNode("button", {
                                            id: "bnrPgSubmitBtn",
                                            class: "admin-btn-outline-primary",
                                            onClick: ($event: any) => (_ctx.submitEditForm(banner.id))
                                          }, _toDisplayString(_ctx.constants.SUBMIT_BUTTON), 9, _hoisted_78),
                                          _createElementVNode("button", {
                                            id: "bnrPgCancelBtn",
                                            class: "admin-btn-outline-secondary addNewCancel",
                                            onClick: _cache[21] || (_cache[21] = 
//@ts-ignore
(...args) => (_ctx.cancelEdit && _ctx.cancelEdit(...args)))
                                          }, _toDisplayString(_ctx.constants.CANCEL_BUTTON), 1)
                                        ])
                                      ])
                                    ])
                                  ]))
                                : _createCommentVNode("", true)
                            ], 2))
                          }), 128))
                        ], 512)
                      ])
                    ])
                  ], 512),
                  _createElementVNode("div", _hoisted_79, [
                    _createElementVNode("div", _hoisted_80, [
                      _createElementVNode("div", _hoisted_81, [
                        _withDirectives(_createElementVNode("select", {
                          id: "paginationSelectBox",
                          "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.limit) = $event)),
                          onChange: _cache[23] || (_cache[23] = 
//@ts-ignore
(...args) => (_ctx.handleLimitChange && _ctx.handleLimitChange(...args)))
                        }, [...(_cache[32] || (_cache[32] = [
                          _createElementVNode("option", { value: "10" }, "10", -1),
                          _createElementVNode("option", { value: "20" }, "20", -1),
                          _createElementVNode("option", { value: "50" }, "50", -1),
                          _createElementVNode("option", { value: "100" }, "100", -1)
                        ]))], 544), [
                          [_vModelSelect, _ctx.limit]
                        ]),
                        _createElementVNode("span", null, _toDisplayString(_ctx.constants.ENTRIES_PER_PAGE_LABEL), 1)
                      ]),
                      (_ctx.totalPages > 1)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_82, [
                            _createElementVNode("ul", null, [
                              (_ctx.currentPage !== 1)
                                ? (_openBlock(), _createElementBlock("li", {
                                    key: 0,
                                    onClick: _cache[24] || (_cache[24] = ($event: any) => (_ctx.changePage(_ctx.currentPage - 1)))
                                  }, [...(_cache[33] || (_cache[33] = [
                                    _createElementVNode("a", {
                                      href: "#",
                                      class: "pagination-previous"
                                    }, null, -1)
                                  ]))]))
                                : _createCommentVNode("", true),
                              (_ctx.totalPages != 1)
                                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.visiblePages, (page) => {
                                    return (_openBlock(), _createElementBlock("li", {
                                      key: page,
                                      onClick: ($event: any) => (_ctx.changePage(page))
                                    }, [
                                      _createElementVNode("a", {
                                        href: "#",
                                        class: _normalizeClass({ active: _ctx.currentPage === page })
                                      }, _toDisplayString(page), 3)
                                    ], 8, _hoisted_83))
                                  }), 128))
                                : _createCommentVNode("", true),
                              (_ctx.currentPage !== _ctx.totalPages)
                                ? (_openBlock(), _createElementBlock("li", {
                                    key: 2,
                                    onClick: _cache[25] || (_cache[25] = ($event: any) => (_ctx.changePage(_ctx.currentPage + 1)))
                                  }, [...(_cache[34] || (_cache[34] = [
                                    _createElementVNode("a", {
                                      href: "#",
                                      class: "pagination-next"
                                    }, null, -1)
                                  ]))]))
                                : _createCommentVNode("", true)
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ], 2))
              : (_openBlock(), _createElementBlock("div", _hoisted_84, [...(_cache[35] || (_cache[35] = [
                  _createElementVNode("p", null, "No data to display", -1)
                ]))]))
          ])
        ])
      ])
    ]),
    _createElementVNode("footer", _hoisted_85, [
      _createElementVNode("div", _hoisted_86, _toDisplayString(_ctx.constants.COPYRIGHT_TEXT), 1)
    ]),
    _createElementVNode("div", _hoisted_87, [
      _createElementVNode("div", _hoisted_88, [
        _createElementVNode("div", _hoisted_89, [
          _cache[36] || (_cache[36] = _createElementVNode("div", { class: "confirmation-popup-icon" }, [
            _createElementVNode("i", null, [
              _createElementVNode("img", {
                src: _imports_1,
                alt: ""
              })
            ])
          ], -1)),
          _createElementVNode("div", _hoisted_90, [
            _createElementVNode("p", null, _toDisplayString(_ctx.constants.ARE_YOU_SURE_YOU_WANT_TO_DELETE_THIS_TEXT), 1)
          ]),
          _createElementVNode("div", _hoisted_91, [
            _createElementVNode("button", _hoisted_92, _toDisplayString(_ctx.constants.NO_BUTTON), 1),
            _createElementVNode("button", {
              id: "popYesBtn",
              class: "admin-btn-outline-primary",
              "data-bs-dismiss": "modal",
              onClick: _cache[26] || (_cache[26] = 
//@ts-ignore
(...args) => (_ctx.confirmDelete && _ctx.confirmDelete(...args)))
            }, _toDisplayString(_ctx.constants.YES_BUTTON), 1)
          ])
        ])
      ])
    ])
  ]))
}